<template>
  <div class="divider">
    <div class="title">
      <slot>
        <span>{{ title }}</span>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { toRefs } from 'vue'
// eslint-disable-next-line
const props = defineProps({
  title: String
})

const { title } = toRefs(props)
</script>

<style lang="scss" scoped>
.divider {
  margin-bottom: 12px;
  padding-top: 16px;

  .title {
    > span {
      color: #333;
      font-weight: 600;
      font-size: 16px;
    }
  }
}
</style>
